export var EncryptionType;
(function (EncryptionType) {
    EncryptionType["ENCRYPTION_TYPE_UNSPECIFIED"] = "ENCRYPTION_TYPE_UNSPECIFIED";
    EncryptionType["ENCRYPTION_TYPE_UNENCRYPTED"] = "UNENCRYPTED";
    EncryptionType["ENCRYPTION_TYPE_PROVIDER_MANAGED_KEY"] = "PROVIDER_MANAGED_KEY";
    EncryptionType["ENCRYPTION_TYPE_CUSTOMER_MANAGED_KEY"] = "CUSTOMER_MANAGED_KEY";
})(EncryptionType || (EncryptionType = {}));
